import { CALCULATOR_RESULT_CARD } from 'components/Widget/shared/cardStyles';
import { CalculatorEnrollmentCta } from 'components/Widget/shared/CalculatorEnrollmentCta';
import { formatCurrency, fromCents } from 'components/Widget/shared/currency';
import { HeroAmount } from 'components/Widget/shared/HeroAmount';
import { cn } from 'utils/styles';
import { frequencyPhrase, RESULT_COPY, RESULT_ROWS } from './constants';
import type { PaycheckPanel } from './types';

interface PaycheckCalculatorResultProps {
  panel: PaycheckPanel;
}

const LABEL = 'text-label-serif text-content-secondary';

export const PaycheckCalculatorResult = ({ panel }: PaycheckCalculatorResultProps) => {
  const { result } = panel;
  const frequency = frequencyPhrase(panel.payFrequency);

  return (
    <div className={cn(CALCULATOR_RESULT_CARD, 'gap-5')}>
      <div>
        <p className={LABEL}>{RESULT_COPY.eyebrow(frequency)}</p>
        <HeroAmount value={fromCents(result.takeHome)} />
      </div>

      <table className="w-full border-collapse text-left">
        <tbody>
          {RESULT_ROWS.map(row => (
            <tr key={row.key} className="border-t border-border-primary first:border-t-0">
              <th scope="row" className={cn(LABEL, 'py-3 pr-3 font-normal')}>
                {row.label(frequency)}
              </th>
              <td className="py-3 text-right text-heading-sm whitespace-nowrap">
                {formatCurrency(fromCents(result[row.key]))}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <CalculatorEnrollmentCta />
    </div>
  );
};
